import script from "./ChangePasswordPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangePasswordPage.vue?vue&type=script&setup=true&lang=js"

import "./ChangePasswordPage.vue?vue&type=style&index=0&id=d92c49da&scoped=true&lang=css"

import exportComponent from "C:\\wisata-jepara-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d92c49da"]])

export default __exports__